<template>
  <article>
    <v-container>
      <div class="icon-info" v-for="(icon, index) in iconSet" :key="index">
        <div class="icon-container">
          <ns-icon :icon-name="icon" :color="color" />
        </div>
        <div
          class="pointer"
          v-clipboard:copy="returnIconHTML(icon)"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >{{icon}}</div>
      </div>
      <v-flex sm12>
        <div class="progress-color feedback" v-if="copySucceeded === true">Copy Successful</div>
        <div class="color-error" v-if="copySucceeded === false && show === true">Copy Successful</div>
      </v-flex>
    </v-container>
  </article>
</template>

<script>
import iconset from "./icons.js";
import NsIcon from "./NsIcon.vue";

export default {
  name: "NsIconset",
  components: { NsIcon },
  props: {
    /**
     * Change the color of all NsIcon examples that don't have color set within their SVG code
     */
    color: {
      type: String,
      default: "#272525"
    }
  },
  data() {
    return {
      show: false,
      copySucceeded: null,
      iconSet: this.setIconSet()
    };
  },
  mounted() {},
  methods: {
    setIconSet() {
      let iconKeys = [];
      Object.keys(iconset).forEach(icon => {
        iconKeys.push(icon);
      });

      return iconKeys;
    },
    onCopy: function() {
      this.copySucceeded = true;
      setTimeout(() => (this.copySucceeded = false), 1500);
    },
    onError: function() {
      this.copySucceeded = false;
    },
    returnIconHTML(icon) {
      return `<ns-icon icon-name="${icon}" />`;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-wrap: wrap;
}

.icon-info {
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  width: calc(100% / 5);
  max-width: 200px;
}

.icon-container {
  height: 30px;
  width: 30px;
  border: 1px dotted var(--dryink);
}

.pointer {
  cursor: pointer;
}

.progress-color {
  background-color: var(--progress-color);
}

.feedback {
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  padding: 15px;
  width: 500px;
  box-shadow: 0 0 4px 0 rgba(18, 19, 21, 0.12),
    0 4px 12px 0 rgba(18, 19, 21, 0.12);
  font-size: 2em;
}
</style>